import { useEffect, useState } from "react";
import { ReactComponent as DefaultDragon } from "../../assets/images/dragon-fruifft.svg";

export const Image = ({ onClick, typeId, Icon, isOpen, id, mode, isPlayed, width }) => {
	const [count, setCount] = useState(0);
	const onClickImage = () => {
		if (!isOpen) {
			setCount((prev) => prev + 1);
			onClick(typeId, id);
		}
	};

	useEffect(() => {
		if (isPlayed) {
			setCount(0);
		}
	}, [isPlayed]);

	const Dragon = isOpen ? Icon : DefaultDragon;

	return (
		<div className={`image-item ${isOpen ? "active" : ""}`} onClick={onClickImage}>
			<Dragon style={{ width }} />

			{isPlayed && <span className="count-info">{count}</span>}
		</div>
	);
};
